'use client'

import WorkItemDisplay from '@/components/_accounts/profile/work-item'
import ProfileAboutSection from './about-section'
import CommunitiesSection from './communities'
import GamesSection from './games'
import MyWorkSection from './my-work'

const MyFeaturedWorkSection = ({ workSample }) => {
  return (
    <div className="mt-2 flex w-full flex-col gap-4">
      <p className="text-center font-syncopate text-2xl font-bold uppercase text-shades-0 xl:text-start">
        My Featured Work
      </p>
      <div className="flex aspect-video">
        <WorkItemDisplay workSample={workSample} />
      </div>
    </div>
  )
}

export default function ViewCommentatorProfile({ user, communities }) {
  if (user?.commentatorConfig) {
    const { commentatorConfig } = user
    return (
      <div className="flex flex-col gap-4 px-4 xl:px-0">
        {/* ABOUT ME */}
        <ProfileAboutSection
          bio={commentatorConfig.description}
          availability={commentatorConfig.availability}
        />

        {/* MY FEATURED WORK */}
        {user.userCommentatorWorkSamples?.length > 0 && (
          <MyFeaturedWorkSection
            workSample={user.userCommentatorWorkSamples[0]}
          />
        )}

        {/* MY WORK */}
        <MyWorkSection workSamples={user.userCommentatorWorkSamples} />

        {/* GAMES I COMMENTATE */}
        <GamesSection
          type="commentator"
          games={user.commentatorGames}
          user={user}
        />

        {/* COMMUNITIES */}
        <CommunitiesSection communities={communities} />
      </div>
    )
  } else {
    return (
      <div className="flex flex-col gap-4">
        <div className="rounded-md bg-neutral-blue-800 px-4 py-10 text-center">
          <h4 className="text-h-4 font-semibold">No commentator Profile</h4>
          <p className="mt-2">
            This user does not have a commentator profile yet. Information and
            activities related to driving will appear here once a profile is
            completed.
          </p>
        </div>
      </div>
    )
  }
}
